import UserDisplay from './UserDisplay'
import PortionSelector from './PortionSelector';
import { IconButton } from "@material-ui/core"
import LogoutIcon from '@mui/icons-material/Logout';
import LoginIcon from '@mui/icons-material/Login';

const Header = ({ username, portions, setPortions, mealView, setMealView, isLoggedIn, logout, login }) => {
    return (
        <header className='header'>
            <div className="flex">
                <div className="width15">
                </div>
                <div className="width70">
                    <h1>Meal Ideas</h1>
                </div>
                {isLoggedIn ?
                    <div className="width15 flex vertical-center">
                        <UserDisplay username={username}></UserDisplay>
                        <IconButton className="shrink" onClick={() => { logout({ returnTo: window.location.origin }) }}>
                            <LogoutIcon ></LogoutIcon>
                        </IconButton>
                    </div> :
                    <div className="width15 flex vertical-center">
                        <IconButton onClick={() => { login() }}>
                            <LoginIcon ></LoginIcon>
                        </IconButton>
                    </div>}
            </div>
            <div>
                <div className="flex-only">
                    <div className="width60">
                        <PortionSelector portions={portions} setPortions={setPortions}></PortionSelector>
                    </div>
                    <div className="width40 ">
                        {/* <select name="cars" id="cars" className="dropdown"> */}
                        <select name="viewSelector" id="viewSelector" value={mealView} onChange={(e) => setMealView(e.target.value)} className="dropdown">
                            <option value="all-meals">All Meals</option>
                            <option value="favorite-meals">Favorites</option>
                            <option value="own-meals">Own Meals</option>
                        </select>
                    </div>
                </div>
            </div>
        </header>
    )
}

export default Header
